<template>
  <CHeader with-subheader style="background-color: #4786ff !important;">
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-12">
      </CHeaderNavItem>
    </CHeaderNav>
    <CHeaderNav>
      <TheHeaderDropdownAccnt/>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import router from '../router/index'
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import account_ws from '../services/account';
import login from '../services/login';

export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt
  },
  data () {
    return { 
      
    }
  },
  mounted: async function() {
    
  },
  methods: {
    logout: function(){
      
      localStorage.removeItem("account");
      localStorage.removeItem("domain");
      localStorage.removeItem("token");

      router.push("login");
    },
  }
}
</script>
